module.exports = __webpack_public_path__ + "img/sam-kirk-mobile-background.3419f411.jpg";